import script from "./MerchLList.vue?vue&type=script&setup=true&lang=js"
export * from "./MerchLList.vue?vue&type=script&setup=true&lang=js"

import "./MerchLList.vue?vue&type=style&index=0&id=050104d3&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-050104d3"]])

export default __exports__